import { UK_POSTCODE_REGEX } from 'constants/constants';
import { postcodeRequired, invalidPostcode } from './errorMessages';

const validatePostcode = (
  value,
  { inputField, validationField, setValue, setError, clearErrors },
) => {
  if (value === '') {
    setError(inputField, {
      type: 'required',
      message: postcodeRequired,
    });
  } else if (!UK_POSTCODE_REGEX.test(value)) {
    setError(inputField, {
      type: 'invalid',
      message: invalidPostcode,
    });
  } else {
    setValue(validationField, true);
    clearErrors(inputField);
  }
};

const validateRequired = (
  value,
  {
    inputField,
    validationField,
    errorMessage,
    setValue,
    setError,
    clearErrors,
  },
) => {
  if (value === '') {
    setError(inputField, {
      type: 'required',
      message: errorMessage,
    });
  } else {
    setValue(validationField, true);
    clearErrors(inputField);
  }
};

export { validatePostcode, validateRequired };
